export default __webpack_public_path__ + "static/media/movie.b1ca4b20.png";